import { Info, AccountTree } from "@mui/icons-material";

export const tabs = [
  {
    icon: <Info />,
    entity: "detail",
    label: "Detalhes",
  },
  {
    icon: <AccountTree />,
    entity: "processes",
    label: "Processos",
  },
];
